import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-center overflow-hidden pt-24"
    >
      {/* Left content / Right image asymmetric layout */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 items-center w-full">
        <div className="md:col-span-7 relative z-10 fade-up">
          <p
            data-testid="hero-eyebrow"
            className="text-xs md:text-sm tracking-[0.35em] uppercase text-[#7B8E76] mb-8"
          >
            Certified Yoga Therapy · Marissa Rajpaul
          </p>
          <h1
            data-testid="hero-headline"
            className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.05] text-[#2D3A2B] tracking-tight"
          >
            Your Guided Path to{" "}
            <span className="italic text-[#4A5D46]">Personal Elevation</span>:
            Integrating Deep Healing with True Self-Mastery.
          </h1>
          <p
            data-testid="hero-subheadline"
            className="mt-8 text-lg md:text-xl text-[#4A5D46] leading-relaxed max-w-xl font-light"
          >
            A personalized, holistic approach that uses the tools of yoga to
            support your overall health and wellbeing.
          </p>
          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <Link to="/contact" data-testid="hero-cta-book">
              <Button className="rounded-full bg-[#8A9A83] hover:bg-[#7B8E76] text-white px-8 py-6 h-auto text-base group">
                Book a Consultation
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <Link to="/services" data-testid="hero-cta-learn">
              <Button
                variant="outline"
                className="rounded-full border-[#2D3A2B] text-[#2D3A2B] hover:bg-[#2D3A2B] hover:text-[#FDFCFB] px-8 py-6 h-auto text-base bg-transparent"
              >
                Explore Yoga Therapy
              </Button>
            </Link>
          </div>
        </div>

        <div className="md:col-span-5 relative">
          <div className="relative aspect-[4/5] rounded-sm overflow-hidden shadow-[0_20px_60px_rgba(45,58,43,0.15)]">
            <img
              src="https://customer-assets-7cd3h4nn.emergentagent.net/job_grounded-wellness-3/artifacts/0izw87fm_Gemini_Generated_Image_28kc7b28kc7b28kc.webp"
              alt="Marissa meditating in a sunlit meadow"
              className="w-full h-full object-cover"
              data-testid="hero-image"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#2D3A2B]/25" />
          </div>
          <div className="hidden md:block absolute -bottom-8 -left-8 bg-[#F4F1ED] border border-[#E8E5DF] p-6 max-w-[240px] shadow-[0_8px_32px_rgba(45,58,43,0.06)]">
            <p className="font-serif italic text-[#4A5D46] text-lg leading-snug">
              &ldquo;A practice tailored specifically to your body and your
              goals.&rdquo;
            </p>
          </div>
        </div>
      </div>

      {/* Decorative botanical accent */}
      <div className="absolute top-24 right-0 w-64 h-64 rounded-full bg-[#C6A692]/10 blur-3xl -z-0" aria-hidden />
      <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full bg-[#8A9A83]/10 blur-3xl -z-0" aria-hidden />
    </section>
  );
};

export default Hero;
